import React from "react";

export default function Placeholder({ title, phase, description, testid }) {
  return (
    <div data-testid={testid || "placeholder-page"} className="space-y-8">
      <div>
        <div className="pb-eyebrow">{phase}</div>
        <h1 className="font-serif text-4xl text-navy mt-2">{title}</h1>
      </div>
      <div className="pb-placeholder">
        {description || `Folgt in nächster Phase (${phase}).`}
      </div>
    </div>
  );
}
